export class GetPowerSkills {
  static readonly type = "[PowerSkills] Get power skills";
}
